import { createStyles } from "@material-ui/styles";
import { Theme } from "@material-ui/core";

export const styles = (theme: Theme) =>
  createStyles({
    root: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      marginTop: "64px",
      marginBottom: "50px",
      padding: "32px",
    },
    titleGroup: {
      display: "flex",
      alignItems: "center",
      marginBottom: "12px",
      alignSelf: "flex-start",
    },
    title: {
      fontSize: "22px",
      fontWeight: "bold",
    },
    subtitle: {
      marginBottom: "48px",
    },
    link: {
      color: theme.palette.primary.main,
      textDecoration: "none",
    },
    image: {
      marginBottom: "12px",
    },
  });
